import { Component, OnInit } from '@angular/core';
import { FilterListComponent } from '../filter-list/filter-list.component';

@Component({
    selector: 'lib-top-filter-list',
    templateUrl: './top-filter-list.component.html',
    styleUrls: ['./top-filter-list.component.scss'],
    standalone: false
})
export class TopFilterListComponent<T> extends FilterListComponent<T> {}
